import { Component, ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/seguranca/auth.service';
import { JuridicoService } from '../juridico.service';

@Component({
  selector: 'app-processo',
  templateUrl: './processo.component.html',
  styleUrls: ['./processo.component.css']
})
export class ProcessoComponent implements OnInit {

  token: any;
  idSocio = 0;
  processos = [];
  playLoad: any

  renovarLoginDialog = false;
  aguardeDialog = true;

  constructor(
    private juridicoService: JuridicoService,
    private rota: ActivatedRoute,
    private erro: ErrorHandler,
    private auth: AuthService,
    private rotaNavegar: Router,
    private jwtDecoder: JwtHelperService,
    private toasty: ToastrService
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('access_token_xmanager');
    this.playLoad = this.jwtDecoder.decodeToken(this.token);
    window.scrollTo(0, 0);
    this.idSocio = this.rota.snapshot.params.id;
    this.buscarProcessosPorIdSocio();
  }

  buscarProcessosPorIdSocio() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.aguardeDialog = true;
      this.juridicoService.buscarListaProcessosPorIdSocio(this.idSocio, this.token).subscribe(
        (dados: any) => {
          this.processos = dados;
          this.aguardeDialog = false;
        },
        erro => {
          this.erro.handleError(erro);
          this.aguardeDialog = false;
        });
    } else {
      this.renovarLoginDialog = true;
    }
  }

  rotaNavegacaoProcesso(id: number) {
    if (!this.auth.isAccessTokenInvalido()) {
      this.rotaNavegar.navigate(['/movimentacao', id]);
    } else {
      this.renovarLoginDialog = true;
    }
  }

  login(usuario: string, senha: string) {
    this.aguardeDialog = true;
    this.auth.renovarLogin(usuario, senha).subscribe(
      (dados: any) => {
        this.token = dados.access_token;
        this.auth.armazenarToken(dados.access_token);
        this.playLoad = this.jwtDecoder.decodeToken(this.token);
        this.aguardeDialog = false;
        this.renovarLoginDialog = false;
      }, erro => {
        if (erro.status === 400) {
          if (erro.error.error === 'invalid_grant') {
            this.aguardeDialog = false;
            this.toasty.error('USUÁRIO OU SENHA INVÁLIDO!', 'ATENÇÃO!');
            this.rotaNavegar.navigate(['']);
          }
        }
        this.aguardeDialog = false;
        this.erro.handleError(erro);
        this.rotaNavegar.navigate(['']);
      });
  }
}
